import { render, staticRenderFns } from "./ZoneProperties.vue?vue&type=template&id=193ef310&scoped=true"
import script from "./ZoneProperties.vue?vue&type=script&lang=js"
export * from "./ZoneProperties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193ef310",
  null
  
)

export default component.exports